<template>
  <section class="landing-page-container">
    <Header v-if="headerVisible" @languageChanged="languageChangedHandler" />
    <Hero v-if="template.hero.visible" />
    <Description v-if="template.description.visible" />
    <Sponsors v-if="template.sponsors.visible" />
    <Speakers v-if="template.speakers.visible" :eventId="$store.state.eventId" />
    <More v-if="template.more.visible" />
    <div v-html="customHtml" v-if="template.html.visible"></div>
    <iframe class="landing-page-iframe" v-if="template.iframe.visible" :src="template.iframe.src" frameborder="0"></iframe>
    <Login :key="loginKey" v-if="accessConfig.loginFirst" @enterClicked="updateHeader" />
    <Footer />
  </section>
</template>

<script>
import Header from '@/components/general/Header.vue';
import Hero from '@/components/home/Hero.vue';
import Description from '@/components/home/Description.vue';
import Sponsors from '@/components/home/Sponsors.vue';
import Speakers from '@/components/home/Speakers.vue';
import More from '@/components/home/More.vue';
import Login from '@/components/home/Login.vue';
import Footer from '@/components/general/Footer.vue';

import api from '@/services/api.js';

export default {
  name: 'LandingPage',
  components: { Header, Hero, Description, Sponsors, Speakers, More, Login, Footer },

  data() {
    return {
      template: null,
      customHtml: null,
      accessConfig: null,
      headerVisible: false,
      loginKey: 0,
    };
  },
  methods: {
    languageChangedHandler(selectedLanguage) {
      // console.log('language changed on header to: ' + selectedLanguage);

      // let userLanguage = this.$store.state.user.language.toLowerCase();
      this.accessConfig = this.$store.state.template.accessConfig[`accessConfig_${selectedLanguage}`];
      this.accessConfig.loginFirst = true;
      this.$store.commit('setUserLanguage', selectedLanguage);
      this.template.iframe.visible = false;
      this.headerVisible = true;
      this.loginKey++;
    },
    messagesHandler(e) {
      // console.log('PostMessage Received: ' + JSON.stringify(e.data));
      try {
        if (e.data.name) {
          this.$router.push(e.data);
        }
        if (e.data == 'register') {
          this.$router.push({ name: 'Register' }).catch((err) => {
            console.error('navigation error', err);
          });
        }
        if (e.data.languageCode) {
          // console.log('PostMessage Received: ' + JSON.stringify(e.data.languageCode));
          if (this.$store.state.template.multilanguagesConfig) {
            this.accessConfig = this.$store.state.template.accessConfig[`accessConfig_${e.data.languageCode}`];
            this.accessConfig.loginFirst = true;
            this.$store.commit('setUserLanguage', e.data.languageCode);
            this.template.iframe.visible = false;
          }
        }
      } catch (error) {
        console.error('error on postMessage', error);
      }
    },
    updateHeader() {
      // console.log('USER CLICKED ENTER');
      this.headerVisible = false;
    },
  },

  beforeMount() {
    this.template = this.$store.state.template.home;
    this.customHtml = this.template.html.src;
    this.accessConfig = this.$store.state.template.accessConfig;

    if (this.$store.state.template.multilanguagesConfig) {
      this.template.iframe.visible = true;
    }
  },
  mounted() {
    window.addEventListener('message', this.messagesHandler, false);
  },
  beforeDestroy() {
    window.removeEventListener('message', this.messagesHandler);
  },
};
</script>

<style>
.landing-page-container {
  position: absolute;
  inset: 0 0 auto 0;
  background-color: var(--main-color);
  width: 100vw;
}
.landing-page-iframe {
  position: fixed;
  width: 100%;
  height: 100dvh;
}
</style>
